import type { EnrolledType } from '../types';

export interface QueryBuilderParams {
  page: number;
  pageSize: number;
  folio?: string;
  stakeholderIdentifier?: string;
  stakeholderName?: string;
  startDate?: string | null;
  endDate?: string | null;
  businessIdentifier?: string;
  requestId?: string;
  enrolledType?: EnrolledType | null;
  selectedIds?: string[];
  overrideEnrolledType?: string;
  manualOverrideKeys?: string[];
  invoiceOverrideKeys?: string[];
  isEnrolled?: boolean;
}

/**
 * Genera una query string para buscar documentos
 * Compatible con DocumentsSelectorDialog y Editor
 */
export const buildDocumentsQuery = (params: QueryBuilderParams): string => {
  const {
    page,
    pageSize,
    folio,
    stakeholderIdentifier,
    stakeholderName,
    startDate,
    endDate,
    businessIdentifier,
    requestId,
    enrolledType,
    selectedIds = [],
    overrideEnrolledType,
    manualOverrideKeys = [],
    invoiceOverrideKeys = [],
    isEnrolled,
  } = params;

  let query = '';

  if (folio) query += `folio=${folio}&`;
  if (stakeholderIdentifier)
    query += `stakeholderIdentifier=${stakeholderIdentifier}&`;
  if (stakeholderName) query += `stakeholderName=${stakeholderName}&`;
  if (businessIdentifier) query += `businessIdentifier=${businessIdentifier}&`;
  if (requestId) query += `requestId=${requestId}&`;
  if (page) query += `page=${page}&pageSize=${pageSize}&`;
  if (startDate) query += `startDate=${startDate}&`;
  if (endDate) query += `endDate=${endDate}&`;

  if (selectedIds.length) {
    const uniqueSelected = Array.from(new Set(selectedIds));
    if (uniqueSelected.length) {
      query += `selectedDocuments=${uniqueSelected.join(',')}&`;
    }
  }

  const hasSearchFilters =
    Boolean(startDate) ||
    Boolean(endDate) ||
    Boolean(stakeholderIdentifier) ||
    Boolean(stakeholderName) ||
    Boolean(folio);

  const effectiveType =
    overrideEnrolledType ??
    enrolledType ??
    (isEnrolled === true ? 'sii' : isEnrolled === false ? 'manual' : undefined);

  if (effectiveType) {
    query += `enrolledType=${effectiveType}&`;
  }

  // Solo agregar prioridades si no hay filtros de búsqueda activos
  if (!hasSearchFilters && effectiveType === 'manual') {
    if (manualOverrideKeys.length) {
      query += `newDocuments=${manualOverrideKeys.join(',')}&`;
    }
  }

  if (!hasSearchFilters && effectiveType === 'sii') {
    if (invoiceOverrideKeys.length) {
      query += `prioritizedInvoices=${invoiceOverrideKeys.join(',')}&`;
    }
  }

  return query.endsWith('&') ? query.slice(0, -1) : query;
};
